<div class="d-flex">
  <ng-content />
  <mwe-info-text-icon
    class="lh-1"
    [colorClass]="colorClass()"
    [infoTextCode]="infoTextCode()"
    [infoTextDescription]="infoTextDescription()"
    [infoTextLink]="infoTextLink()"
    [infoTextTitle]="infoTextTitle()"
    [customUrlOverride]="customUrlOverride()"
    [dataTest]="dataTest()"
    [translations]="translateParams()"
  />
</div>
